<div class="automation-rule-table">
  <div
    class="overlay"
    lumAppLoader
    [loading]="loading"
    [classes]="'loading blur'"
  ></div>
  <table
    *ngIf="rules?.length; else empty"
    class="lum-table lum-table--classic striped"
  >
    <thead>
      <tr>
        <th>Name</th>
        <th>Event</th>
        <th>Conditions</th>
        <th>Actions</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let rule of rules; trackBy: trackById">
        <tr>
          <td>{{ rule?.name }}</td>
          <td>{{ eventKeyValue[rule.trigger] }}</td>
          <td>
            <mat-chip-listbox aria-label="Condition selection">
              <mat-chip
                *ngFor="let condition of rule?.conditions; trackBy: trackById"
                class="lum-chip mr-2"
              >
                {{ conditionKeyValue[condition.type] }}
              </mat-chip>
            </mat-chip-listbox>
          </td>
          <td>
            <mat-chip-listbox aria-label="Condition selection">
              <mat-chip
                *ngFor="let action of rule?.actions; trackBy: trackById"
                class="lum-chip mr-2"
              >
                {{ actionKeyValue[action.type] }}
              </mat-chip>
            </mat-chip-listbox>
          </td>
          <td class="flex justify-end position-sticky" style="right: 0">
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
          </td>
        </tr>
        <mat-menu #menu="matMenu">
          <button (click)="updateRuleEvent.emit(rule)" mat-menu-item> Edit </button>
          <button (click)="onDeleteRule(rule.id)" mat-menu-item>Delete</button>
        </mat-menu>
      </ng-container>
    </tbody>
  </table>

  <ng-template #empty>
    <lum-ui-empty-page
      title="There are no Automation Rules to show"
    ></lum-ui-empty-page>
  </ng-template>
</div>
